module.exports = __webpack_public_path__ + "assets/fa-solid-900.1ab236ed440ee51810c56bd16628aef0.ttf";